module.exports = __webpack_public_path__ + "img/portrait_dummy.453946e9.svg";